import { queryOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

import type { ResApplicantFilters } from './types'

export const getApplicantFiltersQuery = (
  params: {
    pathId?: number
    keyword?: string
  } = {}
) => {
  const payload = {
    path_id: params.pathId,
    keyword: params.keyword,
  }

  return queryOptions<ResApplicantFilters>({
    queryKey: ['applicantFilters', payload],
    queryFn: () => {
      return w.post(payload, API_ENDPOINTS.business.v2.applicant.filters.index).json()
    },
  })
}
